import { useCallback } from "react";
import { feedbackService } from "services/feedback.service";
import { useSessionData } from "helpers";
import { getDocumentUrl } from "./documentUrl";

export function useDocumentUrlResolver() {
  const { business_id, device_token, session_id } = useSessionData();

  const resolveDocumentUrl = useCallback(
    async (docPath: string): Promise<string | null> => {
      if (!business_id || !device_token || !session_id) return null;
      const res = await feedbackService.getDownloadInfo({
        business_id,
        device_token,
        session_id,
        doc_file_path: docPath,
      });
      return res?.data?.download_info ?? null;
    },
    [business_id, device_token, session_id]
  );

  const triggerDownload = useCallback(
    async (docPath: string, docName: string): Promise<void> => {
      if (!docPath) return;
      const url = (await resolveDocumentUrl(docPath)) || getDocumentUrl(docPath);
      if (!url) return;
      const fileName = docName || docPath.split("/").pop() || "document";
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
    },
    [resolveDocumentUrl]
  );

  return { resolveDocumentUrl, triggerDownload };
}
